var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortNumberAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00005 3V11H7.00005V5.41L5.00005 5.949V3.619L7.31305 3H9.00005ZM19 3V16H22L18 21L14 16H17V3H19ZM11 15.5C11.0003 16.0439 10.8527 16.5776 10.573 17.044L8.28905 21H5.97905L7.45205 18.45C6.89143 18.3461 6.37202 18.0846 5.95463 17.6962C5.53723 17.3077 5.23913 16.8084 5.09521 16.2567C4.9513 15.705 4.96753 15.1237 5.14201 14.5809C5.31649 14.0381 5.64199 13.5562 6.08041 13.1917C6.51883 12.8272 7.05203 12.5951 7.61757 12.5226C8.18311 12.4501 8.7576 12.5403 9.27377 12.7825C9.78995 13.0246 10.2264 13.4089 10.5322 13.8901C10.8379 14.3714 11.0002 14.9298 11 15.5ZM8.00005 16.5C8.26526 16.5 8.51962 16.3946 8.70715 16.2071C8.89469 16.0196 9.00005 15.7652 9.00005 15.5C9.00005 15.2348 8.89469 14.9804 8.70715 14.7929C8.51962 14.6054 8.26526 14.5 8.00005 14.5C7.73483 14.5 7.48048 14.6054 7.29294 14.7929C7.1054 14.9804 7.00005 15.2348 7.00005 15.5C7.00005 15.7652 7.1054 16.0196 7.29294 16.2071C7.48048 16.3946 7.73483 16.5 8.00005 16.5Z",
    fill: "#5A5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortNumberAsc);
export default __webpack_public_path__ + "static/media/sort-number-asc.c00a1c5e84f6fdd2a41daf2d5020f319.svg";
export { ForwardRef as ReactComponent };